export default {
  SERVICE_FEE: .08,

  // FRONT_END_URL: 'https://app.teletails.com',
  FRONT_END_URL: 'https://instant.teletails.com',
  // FRONT_END_URL: 'http://localhost:3001',
  // FRONT_END_URL: 'https://76def040.ngrok.io',
  // FRONT_END_URL: 'https://instant.teletails.com',

  // BASE_URL: 'http://localhost:3000/data',
  // CHAT_URL: 'http://localhost:8000',
  // NOTIF_URL: 'http://localhost:4000',

  // BASE_URL: 'https://data-admin.teletails.com/data',
  // CHAT_URL:  'https://chat-prod.teletails.com',
  // NOTIF_URL: 'https://chat-prod.teletails.com',

  // BASE_URL: 'http://192.168.68.100:3000/data',
  // CHAT_URL: 'http://192.168.68.100:8000',
  // NOTIF_URL: 'http://192.168.68.100:4000',
  
  // BASE_URL:  'https://data.teletails.com/data',
  // CHAT_URL:  'https://data.teletails.com',
  // NOTIF_URL: 'https://data.teletails.com'

  BASE_URL:  'https://data-prod.teletails.com/data',
  CHAT_URL:  'https://chat-prod.teletails.com',
  NOTIF_URL: 'https://chat-prod.teletails.com',

  // BASE_URL:  'https://data-dev.teletails.com/data',
  // BASE_URL:  'https://chat-dev.teletails.com/data',
  // CHAT_URL:  'https://chat-dev.teletails.com',
  // NOTIF_URL: 'https://chat-dev.teletails.com',
  
  // BASE_URL:  'https://chat-prod.teletails.com/data',
  // CHAT_URL:  'https://chat-prod.teletails.com',
  // NOTIF_URL: 'https://chat-prod.teletails.com',

  // BASE_URL:  'https://data-prod.teletails.com/data',
  // CHAT_URL:  'https://data-prod.teletails.com',
  // NOTIF_URL: 'https://data-prod.teletails.com',
}